import styles from '@/components/Common/Nav/Nav.styles';
import { LinkProps } from './Link/Link.utils';
import { SxProps } from '@mui/material';

// INTERFACES

export interface PROPS {
  links: LinkProps[];
  collapse?: boolean;
  horizontal?: boolean;
  sx?: SxProps;
}

// FUNCTIONS
export const GET_WRAPPER_STYLES = (horizontal: boolean) => {
  return { ...styles.nav, ...(horizontal ? styles.nav.horizontal : {}) };
};

export const GET_DIRECTION = (horizontal: boolean) => {
  return horizontal ? 'row' : 'column';
};

export const GET_SPACING = (horizontal: boolean) => {
  return horizontal ? '' : '12px';
};
